export const ACCESS_TOKEN = "access_token"
